var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignHanging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 88H104V8C104 3.594 100.406 0 96 0S88 3.594 88 8V88H8C3.594 88 0 91.594 0 96S3.594 104 8 104H88V504C88 508.406 91.594 512 96 512S104 508.406 104 504V104H504C508.406 104 512 100.406 512 96S508.406 88 504 88ZM472 136C467.594 136 464 139.594 464 144V368H176V144C176 139.594 172.406 136 168 136S160 139.594 160 144V376C160 380.406 163.594 384 168 384H472C476.406 384 480 380.406 480 376V144C480 139.594 476.406 136 472 136Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignHanging);
export default __webpack_public_path__ + "static/media/sign-hanging.db435f9661093970d1f94ac6d325926a.svg";
export { ForwardRef as ReactComponent };